import './sass/minSidebarMenu.css';
import { useEffect, useState } from 'react';
import { isInViewport } from '../../../../helpers/Utils';
import { useMinSideBarMenu } from '../../../../hooks/useMinSidebarMenu';

export const MinSidebarMenu = ({ showClient, contentComp, id, className, name, clicMenu}) => {

    const [classOutViewport, setClassOutViewport ] = useState("");
    const classNameCustom = className ? `${className} ${classOutViewport}` : classOutViewport;
    const [visible, setVisible] = useState(showClient);
    const { ref } = useMinSideBarMenu({setVisible, "visible" : visible, clicMenu});

    useEffect(() => {
        if(showClient && id && classOutViewport !== "out-view-port" && !isInViewport(id) ){
            setClassOutViewport("out-view-port");
        } else if(classOutViewport !== "" && id && !isInViewport(id)){
            setClassOutViewport("");
        }
        if(showClient !== visible){
            setVisible(showClient);
        }
    }, [showClient, visible, classOutViewport, id]);

    return (
        showClient && visible && <>
        <div id={id} className={`list-min ${classNameCustom} overflow-y`} ref={ref}>
            {name && <div id={`${id}title`} className="name">
                {name}
            </div>
            }
            <div id={`${id}content`} className="content">
                {contentComp}
            </div>
        </div>
        </>
    );

};
